$(function($){

  if ($('.experts-slider').length == 0) {
    return;
  }

  let href = $('.socials .icon use').attr('href').split('#')[0];
  $('.experts-slider').slick({
    dots: true,
    prevArrow:
      `<button type="button" class="slick-arrow slick-prev">
        <svg class="icon" width="18" height="16" viewBox="0 0 18 16">
          <use href="${href}#icon_more"></use>
        </svg>
      </button>`,
    nextArrow:
      `<button type="button" class="slick-arrow slick-next">
        <svg class="icon" width="18" height="16" viewBox="0 0 18 16">
          <use href="${href}#icon_more"></use>
        </svg>
      </button>`,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 6,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 767,
        settings: {
          rows: 2,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });



});
